export default __webpack_public_path__ + "static/media/mobile-path.67471db1.png";